module.exports = __webpack_public_path__ + "static/media/Stop.c461d474.svg";